import { Star } from 'lucide-react';

interface ProductRatingProps {
  average: number;
  count: number;
  className?: string;
}

export const ProductRating = ({ average, count, className = '' }: ProductRatingProps) => {
  const stars = Array.from({ length: 5 }, (_, i) => i + 1);

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex gap-1">
        {stars.map((star) => (
          <Star
            key={star}
            className={`w-4 h-4 ${
              star <= average
                ? 'fill-brand-primary text-brand-primary'
                : 'fill-dark-border-default text-dark-border-default'
            }`}
          />
        ))}
      </div>
      <span className="text-sm text-dark-text-secondary">({count})</span>
    </div>
  );
};
